export enum RadFolderEnum {
  RAD1 = 'RAD1',
  RAD2 = 'RAD2',
  RAD3 = 'RAD3',
  RAD4 = 'RAD4',
  RAD5 = 'RAD5',
  RAD6 = 'RAD6'
}

export const RadFolderEnumMapping: Record<RadFolderEnum, string> = {
  [RadFolderEnum.RAD1]: 'Pli Directeur',
  [RadFolderEnum.RAD2]: 'Pli Prof FH Europe',
  [RadFolderEnum.RAD3]: 'Pli C4/OTO/IF',
  [RadFolderEnum.RAD4]: 'Pli FH Malte',
  [RadFolderEnum.RAD5]: 'Pli FAC Malte',
  [RadFolderEnum.RAD6]: 'Pli Chaperon USA'
}
